import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { AxiosInstance } from 'axios';

import { IUser } from '../../../../interfaces/entities';

import { Input } from './Input';
import { Chat } from './Chat';

import { errorMessageAdapter } from '../../../../adapters';
import { ChatService } from '../../../../services/ChatService';
import { useApi } from '../../../../services/hooks/apiHook';

import { useAuth } from '../../../../store/auth';
import { useMailStore } from '../store/mail.store';

import { errorToast } from '../../../../utils/toasts';

const ChatsList: React.FC = () => {
  const [users, setUsers] = useState<IUser[]>([]);
  const [search, setSearch] = useState('');

  const { token } = useAuth();
  const { i18n } = useTranslation();
  const { setSelectedUser, selectedUser } = useMailStore();

  const api: AxiosInstance = useApi();

  const searchUsers = useCallback(
    async (query = '') => {
      try {
        const { users } = await ChatService.listUsers(
          api,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Language': i18n.language.toLowerCase()
            }
          },
          { name: query }
        );

        setUsers(users);
      } catch (e) {
        errorToast(errorMessageAdapter(e));
      }
    },
    [api, i18n.language, token]
  );

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      void searchUsers(search);
    }
  };

  const hasFetchedInitialRef = useRef(false);

  useEffect(() => {
    if (hasFetchedInitialRef.current) {
      return;
    }

    hasFetchedInitialRef.current = true;
    void searchUsers();
  }, [searchUsers]);

  return (
    <div className="flex h-full flex-col gap-3 rounded-lg border-[2px] border-solid border-[#E1E9EF] bg-white p-4">
      <div className="mb-2">
        {/* <h3 className="mb-3 text-lg font-bold text-[#0C1FAA]">{t('labels.lblSearchPeople')}</h3> */}
        <Input
          placeholder={t('labels.lblSearchPeople') || ' '}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>
      <div className="flex flex-1 flex-col gap-2 overflow-auto">
        {users.map((user) => (
          <Chat key={user.id} onClick={setSelectedUser} user={user} focus={user.id === selectedUser?.id} />
        ))}
      </div>
    </div>
  );
};

export { ChatsList };
